/* 
 * Referred this directive implementation from `https://christianliebel.com/2016/05/angular-2-a-simple-click-outside-directive/`
 * @desc This detects an outside click other than hosted element and emits an event 
 * @Usage Add this directive to an element and bind a function or anything to `clickOutside` event on the same element on which directive is applied
*/

import { Directive, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
	selector: '[appOutsideClick]'
})
export class OutsideClickDirective {

	constructor(private _elementRef: ElementRef) { }

	@Output()
	public clickOutside = new EventEmitter();

	@HostListener('document:click', ['$event.target'])
	public onClick(targetElement) {
		const clickedInside = this._elementRef.nativeElement.contains(targetElement);
		if (!clickedInside) {
			this.clickOutside.emit(null);
		}
	}


}
